module.exports = __webpack_public_path__ + "static/media/metallic-chirp.d63e761d.webm";